import LegalLayout, { LegalSection, LegalList } from "@/pages/legal/LegalLayout";
import { COMPANY } from "@/lib/company";

export default function TermsPage() {
  return (
    <LegalLayout
      title="Termini e Condizioni del Servizio"
      subtitle="Condizioni generali che regolano l'utilizzo del sito e la richiesta del servizio di visite mediche assistite a domicilio."
      updated="giugno 2026"
      testId="terms-page"
    >
      <LegalSection number="1" title="Identità del fornitore">
        <p>
          Il sito {COMPANY.site} e il servizio ivi presentato sono gestiti da{" "}
          <strong>{COMPANY.name}</strong>, con sede legale in {COMPANY.address}, P.IVA e C.F. {COMPANY.vat},
          REA {COMPANY.rea}, email{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-[#5B2C91] underline underline-offset-2">{COMPANY.email}</a>{" "}
          (di seguito, la "Società").
        </p>
        <p>
          L'accesso al sito e la richiesta del servizio comportano l'accettazione dei presenti Termini e
          Condizioni. Se l'utente non intende accettarli, è invitato a non utilizzare il sito e a non
          richiedere il servizio.
        </p>
      </LegalSection>

      <LegalSection number="2" title="Oggetto del servizio">
        <p>
          La Società organizza ed eroga <strong>visite mediche assistite a domicilio</strong>: un
          infermiere abilitato si reca presso il domicilio indicato dall'utente munito del dispositivo di
          telemedicina TytoCare, mediante il quale un medico (medico generalista o specialista),
          collegato in diretta da remoto, effettua la visita, esegue le rilevazioni cliniche consentite
          dal dispositivo e, ove appropriato, redige un referto.
        </p>
        <p>
          Le prestazioni sanitarie sono rese esclusivamente da medici iscritti all'Ordine dei Medici
          Chirurghi e Odontoiatri e da infermieri iscritti ai rispettivi Ordini professionali, nel
          rispetto della normativa vigente in materia di professioni sanitarie e di telemedicina.
        </p>
        <p>
          Il servizio è attualmente disponibile a Roma e provincia; l'area di copertura può variare e
          viene confermata in fase di richiesta.
        </p>
      </LegalSection>

      <LegalSection number="3" title="Natura del servizio e limiti — non è un servizio di emergenza">
        <p>
          <strong>Il servizio non è un servizio di emergenza-urgenza</strong> e non sostituisce il
          Servizio Sanitario Nazionale, il numero unico di emergenza 112, il 118 o il pronto soccorso.
          In presenza di condizioni potenzialmente gravi o urgenti (a titolo esemplificativo: dolore
          toracico, difficoltà respiratoria severa, perdita di coscienza, emorragie, sintomi
          neurologici acuti) l'utente deve contattare immediatamente il 112/118 o recarsi al pronto
          soccorso.
        </p>
        <p>
          Il servizio non sostituisce il rapporto con il medico di medicina generale o con il pediatra
          di libera scelta. Il medico collegato da remoto valuta autonomamente, secondo scienza e
          coscienza, se la visita in telemedicina assistita sia appropriata al caso concreto e può in
          ogni momento indirizzare il paziente verso una visita in presenza o verso strutture sanitarie
          idonee.
        </p>
      </LegalSection>

      <LegalSection number="4" title="Richiesta del servizio e conclusione del contratto">
        <p>La richiesta del servizio avviene tramite contatto WhatsApp ai recapiti indicati sul sito. Il processo è il seguente:</p>
        <LegalList
          items={[
            "l'utente invia la richiesta indicando l'esigenza, la zona e le disponibilità orarie;",
            "la Società verifica la disponibilità e comunica all'utente il prezzo complessivo della prestazione, comprensivo di ogni onere, prima della conferma;",
            "il contratto si conclude con la conferma espressa dell'appuntamento da parte dell'utente successiva alla comunicazione del prezzo.",
          ]}
        />
        <p>
          Le informazioni pubblicate sul sito (incluse quelle della pagina "Prezzi") costituiscono un
          invito a proporre e non un'offerta al pubblico; il corrispettivo puntuale è sempre confermato
          prima della conclusione del contratto.
        </p>
      </LegalSection>

      <LegalSection number="5" title="Prezzi e pagamento">
        <p>
          I prezzi sono espressi in euro e comprensivi delle imposte applicabili. Il pagamento avviene
          secondo le modalità comunicate in fase di conferma dell'appuntamento. La Società emette il
          documento fiscale previsto dalla normativa vigente; le prestazioni sanitarie possono essere
          detraibili nei limiti e alle condizioni di legge.
        </p>
      </LegalSection>

      <LegalSection number="6" title="Annullamento, riprogrammazione e diritto di recesso">
        <p>
          L'utente può riprogrammare o annullare la visita, senza alcun costo, comunicandolo tramite
          WhatsApp <strong>fino a 24 ore prima</strong> dell'orario concordato. In caso di annullamento
          oltre tale termine o di assenza al domicilio all'orario concordato, la Società si riserva di
          addebitare un importo a copertura dei costi organizzativi sostenuti, comunicato in fase di
          conferma.
        </p>
        <p>
          Ai sensi dell'art. 47, comma 1, lett. b) del D.Lgs. 206/2005 (Codice del Consumo), i contratti
          aventi ad oggetto servizi di assistenza sanitaria sono esclusi dall'ambito di applicazione
          delle disposizioni sui contratti a distanza, ivi incluso il diritto di recesso di cui all'art.
          52. Resta ferma la facoltà di annullamento gratuito di cui al paragrafo precedente, concessa
          dalla Società a titolo di politica commerciale.
        </p>
      </LegalSection>

      <LegalSection number="7" title="Obblighi dell'utente">
        <LegalList
          items={[
            "fornire informazioni veritiere, complete e aggiornate, anche di carattere anamnestico, necessarie all'erogazione della prestazione;",
            "garantire l'accesso al domicilio in condizioni di sicurezza e igiene adeguate per il personale sanitario;",
            "per visite a minori o a persone sottoposte a tutela, garantire la presenza di chi esercita la responsabilità genitoriale o del tutore e prestare i consensi richiesti;",
            "utilizzare il sito e i canali di contatto in modo lecito, senza arrecare danno a terzi o alla Società.",
          ]}
        />
      </LegalSection>

      <LegalSection number="8" title="Responsabilità">
        <p>
          Le prestazioni sanitarie sono eseguite da professionisti abilitati, i quali operano secondo
          le leges artis e rispondono del proprio operato professionale ai sensi della normativa
          vigente, ivi inclusa la Legge 8 marzo 2017, n. 24. La Società risponde dell'organizzazione
          del servizio nei limiti di legge.
        </p>
        <p>
          La Società non è responsabile per inadempimenti o ritardi dovuti a causa di forza maggiore,
          caso fortuito o fatto del terzo, né per l'impossibilità di erogare la prestazione derivante da
          informazioni errate o incomplete fornite dall'utente. Nulla nei presenti Termini esclude o
          limita la responsabilità della Società nei casi in cui essa non possa essere esclusa o
          limitata ai sensi della legge applicabile.
        </p>
      </LegalSection>

      <LegalSection number="9" title="Proprietà intellettuale">
        <p>
          I contenuti del sito (testi, grafiche, loghi, immagini, layout) sono di titolarità della
          Società o dei rispettivi licenzianti e sono protetti dalla normativa in materia di diritto
          d'autore e proprietà industriale. Ne sono vietati la riproduzione, la distribuzione e
          l'utilizzo non autorizzati. "TytoCare" è un marchio del rispettivo titolare, utilizzato per
          identificare il dispositivo di telemedicina impiegato nel servizio.
        </p>
      </LegalSection>

      <LegalSection number="10" title="Protezione dei dati personali">
        <p>
          Il trattamento dei dati personali degli utenti, ivi inclusi i dati relativi alla salute, è
          disciplinato dall'informativa disponibile alla pagina{" "}
          <a href="/privacy-policy" className="text-[#5B2C91] underline underline-offset-2">Privacy Policy</a>,
          che costituisce parte integrante dei presenti Termini.
        </p>
      </LegalSection>

      <LegalSection number="11" title="Legge applicabile, foro competente e risoluzione delle controversie">
        <p>
          I presenti Termini sono regolati dalla legge italiana. Per le controversie con utenti
          consumatori è competente in via esclusiva e inderogabile il giudice del luogo di residenza o
          domicilio del consumatore, se ubicati nel territorio italiano (art. 66-bis del Codice del
          Consumo). Per le controversie con soggetti diversi dai consumatori (es. strutture, RSA,
          aziende) è competente in via esclusiva il Foro di Roma.
        </p>
        <p>
          Il consumatore può inoltre ricorrere alle procedure di risoluzione extragiudiziale delle
          controversie (ADR) di cui agli artt. 141 e seguenti del Codice del Consumo, rivolgendosi agli
          organismi ADR iscritti negli elenchi tenuti dalle autorità competenti.
        </p>
      </LegalSection>

      <LegalSection number="12" title="Disposizioni finali">
        <p>
          L'eventuale nullità o inefficacia di singole clausole non pregiudica la validità delle
          restanti disposizioni. La Società può modificare i presenti Termini in qualsiasi momento; le
          modifiche si applicano ai contratti conclusi successivamente alla loro pubblicazione sul sito.
          La versione vigente è sempre quella pubblicata su questa pagina, con indicazione della data di
          ultimo aggiornamento.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
